import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.prototype.BaseUrl = 'https://emo.yoo-moo.com'
// Vue.prototype.BaseUrl = 'https://emo.yoo-moo.com/bixinTest'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
